angular
    .module('WizApp')
    .component('formControl', {
        require: {
            ngModelCtrl: 'ngModel',
        },
        bindings: {
            labelText: '@',
            labelClass: '@',
            type: '@',
            inputClass: '@',
            inputId: '@',
            name: '@',
            required: '@',
            inputDisabled: '<?',
            ngModel: '<',
            onChange: '&?'
        },
        controller: [
            '$scope',
            function ($scope) {
                const vm = this;

                vm.isFocused = false;
                vm.localModel = null;
                vm.modelErrors = {};
                vm.isErrored = false;
                vm.errorMessage = null;
                vm.disabled = vm.inputDisabled;

                vm.onFocus = onFocus;
                vm.onBlur = onBlur;
                vm.sendChanges = sendChanges;

                vm.isRequired = () => vm.required !== void 0;

                vm.$onInit = () => {
                    vm.localModel = vm.ngModelCtrl.$viewValue || null;

                    vm.sendChanges();

                    vm.ngModelCtrl.$setPristine();
                };

                $scope.$watch(() => JSON.stringify([vm.modelErrors, vm.isFocused]), () => {
                    vm.ngModelCtrl.$error = angular.copy(vm.modelErrors);

                    vm.isErrored = vm.ngModelCtrl.$touched && _.keys(vm.modelErrors).length > 0;

                    if (!vm.isErrored) {
                        return;
                    }

                    vm.errorMessage = vm.isRequired() && _.isEmpty(vm.localModel)
                        ? 'wizbii.core.messages.form.errors.required'
                        : 'wizbii.core.messages.form.errors.invalid';
                });

                if (vm.onChange) {
                    $scope.$watch(() => vm.localModel, value => {
                        vm.onChange({ value });
                    });
                }

                function onFocus() {
                    vm.isFocused = true;
                }

                function onBlur() {
                    vm.isFocused = false;
                    vm.ngModelCtrl.$setTouched();

                }

                function sendChanges() {
                    vm.ngModelCtrl.$setViewValue(vm.localModel || null);
                }
            },
        ],
        // language=HTML
        template:
        `
            <div class="form-group">
                <label
                    for="{{:: $ctrl.inputId }}"
                    class="{{:: $ctrl.labelClass }}"
                    data-ng-class="{'text-darkest': $ctrl.isFocused}"
                >
                    {{:: $ctrl.labelText }}
                    <span
                        data-ng-if="$ctrl.isErrored"
                        class="text-danger float-right"
                    >
                        {[:: $ctrl.errorMessage | trans ]}
                    </span>
                </label>

                <input
                    type="{{:: $ctrl.type || 'text' }}"
                    id="{{:: $ctrl.inputId }}"
                    name="{{:: $ctrl.name }}"
                    class="{{:: $ctrl.inputClass }}"
                    data-ng-class="{
                        'ng-dirty': $ctrl.ngModelCtrl.$dirty,
                        'ng-pristine': $ctrl.ngModelCtrl.$pristine,
                        'ng-touched': $ctrl.ngModelCtrl.$touched,
                        'ng-untouched': $ctrl.ngModelCtrl.$untouched,
                        'ng-valid': $ctrl.ngModelCtrl.$valid,
                        'ng-invalid': $ctrl.ngModelCtrl.$invalid,
                        'form-control--disabled': $ctrl.inputDisabled
                    }"
                    ng-model="$ctrl.localModel"
                    ng-model-options="{ allowInvalid: true }"
                    model-errors="$ctrl.modelErrors"
                    parent-ng-model="$ctrl.ngModelCtrl"
                    ng-required="$ctrl.isRequired()"
                    ng-focus="$ctrl.onFocus()"
                    ng-blur="$ctrl.onBlur()"
                    ng-change="$ctrl.sendChanges()"
                    ng-disabled="$ctrl.inputDisabled"
                >
            </div>
        `,
    });
